module.exports = __webpack_public_path__ + "static/media/loader.b60a03f8.gif";